<template>    
    <div>
        <template v-if="code">
            <p class="code mt-auto">
                {{ code }}
                <button type="button" class="btn btn-sm btn-primary copy" :data-copy="code">Copy</button>
            </p>
        </template>
        <template v-else>
            <button type="button" class="btn btn-sm btn-primary" @click="requestCode" :disabled="isBusy">Request</button>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: null
            },
        },

        data() {
            return {
                isBusy: true,
                code: '',
            }
        },

        mounted() {
            this.getCode();
        },

        methods: {
            // Get the code
            getCode: function() {
                axios.get('/api/me/get-promo-code/' + this.type)
                    .then((response) => {
                        this.code = response.data.code;
                        this.isBusy = false;
                        window.registerCopyElements(); // Adds event listeners for data-copy
                    });
            },
            // Request a code
            requestCode: function() {
                axios.get('/api/me/request-promo-code/' + this.type)
                    .then((response) => {
                        this.code = response.data.code;
                        this.isBusy = false;
                        window.registerCopyElements(); // Adds event listeners for data-copy
                    });
            },
        }
    }
</script>
